import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from '../activeRecord'

class AnnualPhysicalForm extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._employee_id = init.employee_id
    this._mammogram = init.mammogram
    this._form_attachment = init.form_attachment
    this._pap_smear = init.pap_smear
    this._patient_name = init.patient_name
    this._prostate_screening = init.prostate_screening
    this._colon_screening = init.colon_screening
    this._smoking_attestation = init.annual_smoking_attestation
  }

  static shape = {
    employee_id: PropTypes.string.isRequired,
    mammogram: PropTypes.string.isRequired,
    form_attachment: PropTypes.object,
    pap_smear: PropTypes.string.isRequired,
    patient_name: PropTypes.string.isRequired,
    prostate_screening: PropTypes.string.isRequired,
    colon_screening: PropTypes.string.isRequired,
    smoking_attestation: PropTypes.string.isRequired
  }

  get employee_id() {
    return this._employee_id
  }

  get file() {
    return this._file
  }

  get file_scan_status() {
    return this._file_scan_status
  }

  get mammogram() {
    return this._mammogram
  }

  get form_attachment() {
    return this._form_attachment
  }

  get pap_smear() {
    return this._pap_smear
  }

  get patient_name() {
    return this._patient_name
  }

  get prostate_screening() {
    return this._prostate_screening
  }

  get colon_screening() {
    return this._colon_screening
  }

  get smoking_attestation() {
    return this._smoking_attestation
  }
}

export default AnnualPhysicalForm
